import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const StreetEasyIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-6.2 0 26 13"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        clip-rule="evenodd"
        d="m2.8 0h8.4c1.5464 0 2.8 1.2536 2.8 2.8v8.4c0 1.5464-1.2536 2.8-2.8 2.8h-8.4c-1.5464 0-2.8-1.2536-2.8-2.8v-8.4c0-1.5464 1.2536-2.8 2.8-2.8zm4.1972 10.1556v1.6142l.0294.021c.00513-.0079.00979-.0163.01445-.0247h.00001c.00934-.0168.01867-.0336.03174-.0467.26888-.2689.53837-.5372.80786-.8054.64677-.6439 1.29354-1.28777 1.93194-1.94.9464-.9646 1.3104-2.1308 1.1004-3.4608-.1526-.966-.623-1.7668-1.37761-2.3884-.9268-.763-1.99639-1.0458-3.17939-.8624-.8652.1344-1.61.525-2.212 1.1634-.924.9786-1.274 2.1434-1.0472 3.4664.1722 1.0066.6888 1.8228 1.498 2.4458.5964.4592 1.2726.721 2.023.7924.08645.0078.17291.0128.26123.018.03897.0023.07831.0046.11817.0072zm-.252-3.1416v1.1886h-.00028c-.5333 0-1.05541 0-1.58732-.0028v-.0994c0-1.064 0-2.128.0014-3.192 0-.0644-.0098-.1176-.0658-.1568-.1162-.0798-.1582-.1904-.1386-.3304.00574-.04118.00428-.08432.00279-.12853v-.00001c-.0007-.02042-.00139-.04107-.00139-.06186h4.08239c0 .03608.00023.07181.00046.10733l.00001.00024v.00002.00003.00002.00003.00002.00002.00003c.00057.08839.00113.17547-.00187.26326 0 .0196-.02379.0448-.04339.0588-.1316.0924-.1582.217-.1568.3738.00544.79703.00496 1.59321.00447 2.38986l-.00027.68314v.0938h-1.5848v-1.1872zm-.49481.59786v-.5978h-.4998v.5978zm1.99136-.6027v.6076l-.11856.00017h-.00011-.00003-.00004-.00003-.00003-.00004-.00003c-.1175.00026-.23381.00052-.35013-.00157-.0112 0-.0308-.028-.0308-.042-.0028-.1722-.0028-.3444 0-.5166 0-.0154.0238-.0434.0364-.0448.12307-.00336.24525-.00314.36939-.00292zm-1.99416-1.99119h-.497v.5978h.497zm1.00085.5995h-.4998v-.5978h.4998zm.49825-.5978v.5964h.497v-.5964zm-1.49366 1.59383h-.4956v-.5992h.4956zm.99541.00031v-.5978h-.4998v.5978zm.49825 0v-.5978h.4956v.5978z"
        fill={color}
        fill-rule="evenodd"
      />
    </Svg>
  )
}

export default StreetEasyIconSvg
